// not all properties in Doc are going to be present. Make some optional
// export type Doc = {
//   location: string;
//   name: string;
//   language: string;
//   version: string;
//   description: string;
//   fullName: string;
//   dat: string;
//   docLink: string;
//   model: string;
// };

// Danh sách Knowledge (research-docs) theo project. Dùng API /research-docs/list.
import { authManager } from 'utils/authManager';

const apiHost = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
const project = 'document';

function getAuthHeaders() {
    try {
        const token = authManager.getToken();
        if (token) return { Authorization: `Bearer ${token}` };
    } catch (_) {}
    return {};
}

/** Lấy project name từ URL (?id=...) để filter list. */
function getProjectFromUrl() {
    try {
        const id = new URLSearchParams(window.location.search).get('id');
        return id || project;
    } catch (_) {
        return project;
    }
}

export async function getDocs(projectName) {
    try {
        const proj = projectName != null ? projectName : getProjectFromUrl();
        const url = `${apiHost}/research-docs/list?project_name=${encodeURIComponent(proj)}`;
        const response = await fetch(url, { headers: getAuthHeaders() });
        const data = await response.json();
        if (!response.ok) return [];
        const list = Array.isArray(data) ? data : [];
        return list;
    } catch (error) {
        console.warn('getDocs failed:', error);
        return [];
    }
}

export async function getDoc(vectorIdOrProject) {
    try {
        const id = vectorIdOrProject != null ? vectorIdOrProject : new URLSearchParams(window.location.search).get('id');
        if (!id) return [];
        const proj = getProjectFromUrl();
        const url = `${apiHost}/research-docs/list?project_name=${encodeURIComponent(proj)}`;
        const response = await fetch(url, { headers: getAuthHeaders() });
        const data = await response.json();
        if (!response.ok) return [];
        const list = Array.isArray(data) ? data : [];
        const found = list.find((c) => c.id === id || c.name === id);
        return found ? [found] : (list.length ? [list[0]] : []);
    } catch (error) {
        console.warn('getDoc failed:', error);
        return [];
    }
}

export async function getBillings() {
    try {
        const formData = new FormData();
        const user_token = localStorage.getItem('user_token');
        const user_type = localStorage.getItem('user_type');
        formData.append('user_token', user_token);
        formData.append('user_type', user_type);
        const response = await fetch(apiHost + '/billings', {
            method: 'POST',
            body: formData
        });
        return response.data;
    } catch (error) {
        console.log(error);
        return null;
    }
}

export async function getConversations() {
    try {
        const url = `${apiHost}/conversations?project=${encodeURIComponent(project)}`;
        const response = await fetch(url, { headers: getAuthHeaders() });
        const data = await response.json();
        if (!response.ok) return [];
        return Array.isArray(data) ? data : [];
    } catch (error) {
        console.warn('getConversations failed:', error);
        return [];
    }
}

export function getLocalApiKey() {
    const key = localStorage.getItem('DocsGPTApiKey');
    return key;
}

export function getLocalRecentDocs() {
    const doc = localStorage.getItem('DocsGPTRecentDocs');
    return doc;
}

export function setLocalApiKey(key) {
    localStorage.setItem('DocsGPTApiKey', key);
}

export function setLocalRecentDocs(doc) {
    localStorage.setItem('DocsGPTRecentDocs', JSON.stringify(doc));
    let namePath = doc.name;
    if (doc.language === namePath) {
        namePath = '.project';
    }

    let docPath = 'default';
    if (doc.location === 'local') {
        docPath = 'local' + '/' + doc.name + '/';
    } else if (doc.location === 'remote') {
        docPath = doc.language + '/' + namePath + '/' + doc.version + '/' + doc.model + '/';
    }

    fetch(apiHost + '/api/docs_check', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            docs: docPath
        })
    }).then((response) => response.json());
}
